import React, { useEffect, useState } from 'react'
import { Modal, Button, Form, Input, message, DatePicker, Row, Col, Select, ConfigProvider } from 'antd';
import 'antd/dist/antd.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import api from '../../../services/api';
import * as ModalStatusAction from '../../../redux/actions/modalStatus'
import locale from 'antd/lib/locale/pt_BR';

interface ModalEditarOrgaoProps {
    modalStatus?: any,
    orgao?:any,
    setEditarOrgaoModal?: any
}

const ModalEditarOrgao: React.FC<ModalEditarOrgaoProps> = (prop) => {
    let visible = prop.modalStatus[0].visibleEditarOrgao
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const { Option } = Select;
    const { TextArea } = Input;

    useEffect(() => {
        onFill();
    }, [visible])

    const handleCancel = () => {
        prop.setEditarOrgaoModal(false)
    };

    const onFill = ()=>{
        form.setFieldsValue({
            nome:prop.modalStatus[0].orgao?.nome,
            sigla:prop.modalStatus[0].orgao?.sigla
            
        });
    }

    const onFinish = (values: any) => {
        api.put(`Orgao`, {
            OrgaoID: prop.modalStatus[0].orgao?.orgaoID,
            Nome: values.nome,
            Sigla: values.sigla,
            Ativo: prop.modalStatus[0].orgao?.ativo == "Sim"? true: false
        })
        .finally(()=> setLoading(false))
            .then((response) => {
                if (response.data.valido) {
                    message.success('Órgão editado com sucesso')                                        
                        prop.setEditarOrgaoModal(false);                    
                }
                else {
                    message.error(response.data.error)
                }
            })
            .catch((err) => {
                message.error('Falha na requisição')            
            });
      
       
    };


    return (
        <Modal
            visible={visible}
            title="Editar Órgão"
            onCancel={handleCancel}
            footer={null}
        >
            <Form
                name="basic"
                form={form}
                onFinish={onFinish}
            >
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Nome"
                            name="nome"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor insira um nome!',
                                }
                            ]}
                        >
                            <Input placeholder="Digite o Nome do Órgão" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Sigla"
                            name="sigla"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor insira uma Sigla!',
                                }
                            ]}
                        >
                            <Input placeholder="Digite a Sigla do Órgão" />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item>
                    <Button className="button-pre-cadastro" type="primary" htmlType="submit">
                       Alterar
                    </Button>
                </Form.Item>
            </Form>
        </Modal >
    );
}

const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus 
})

const mapDispatcToProps = (dispatch: any) => bindActionCreators(ModalStatusAction, dispatch)

export default connect(mapStateToProps, mapDispatcToProps)(ModalEditarOrgao);